import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

/**
 * Clears any in-progress confirmation when the parent record context changes
 */
export const resetOnContextChange = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: () => State.INITIAL,
    }),
)
